import React from 'react'

import css from './style.module.css'
export default ({ box, line, header, circle, size, style, ...props }) => {
    style = {...style}
    let classes = [css.contentPlaceholder]
    
    if(box) classes.push(css.box)
    if(line) classes.push(css.line)
    if(header) classes.push(css.header)
    if(circle) classes.push(css.circle)
    
    classes = classes.join(' ')

    if(size || box || circle) style.maxHeight = size || box || circle
    if(size || line || header || circle) style.maxWidth = size || line || header || circle
    
    return (
        <div className={classes} style={style} {...props} />
    )
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Placeholder/index.js